// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

$(document).on("turbo:load", function() {

  // Reset select status of first tab
  $("li > a[href='#tab_2']").on('click', () =>
    $("#matter_user_users option").attr("selected", false)
  );

});
